import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddClosedData from "./components/AddClosedData";

const initialData = {
  under_contract_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  closing_date: "",
  initial_date: "",
  contract_date: "",
};


const AddClosedModal = ({ showModal, onClose, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDollar, setIsDollar] = useState(false)

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      under_contract_id: formData.under_contract_id,
      portfolio: formData?.portfolio === 1 ? 1 : 0,
      property: formData.property,
      company_gcl: formData.company_gcl,
      contract_price: formData.contract_price,
      contract_cap_rate: formData.contract_cap_rate,
      closing_date: formData.closing_date,
      initial_date: formData.initial_date,
      contract_date: formData.contract_date,
    };
    axios
      .post(`${BASE_URL}/add-close`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <Modal title={`Add Closed`} desc={`Add the contract closed information.`} show={showModal} onClose={handleClose}>
      <AddClosedData
        formData={formData}
        error={error}
        isSidebarOpen={isSidebarOpen}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        isDollar={isDollar}
        setIsDollar={setIsDollar}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  );
};

export default AddClosedModal;
